import { Outlet } from 'react-router-dom';
import { useAuth } from 'hooks';
import { Header, Main } from 'components';

export function BatchCollectionPage() {
  const { selectedStore } = useAuth();
  const store = selectedStore.name || '';

  return (
    <Main>
      <Header />

      <Outlet key={store} />
    </Main>
  );
}

export * from './outlet';
